import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import CustomInput from '../../../components/input/CustomInput';
import { format } from 'date-fns';

const defaultValues = {
  code: '',
  title_id: '',
  title_en: '',
  value: 0,
  valid_from: '',
  valid_thru: '',
  quota: 0
};

function ViewVoucherModal({ data }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setValue('code', data.code);
      setValue('title_id', data.title_id);
      setValue('title_en', data.title_en);
      setValue('value', data.value);
      setValue('quota', data.quota);
      setValue('used', data.used);
      setValue('valid_from', format(new Date(data.valid_from), 'yyyy-MM-dd'));
      setValue('valid_thru', format(new Date(data.valid_thru), 'yyyy-MM-dd'));
      setValue('created_at', format(new Date(data.created_at), 'yyyy-MM-dd'));
      setValue('updated_at', format(new Date(data.updated_at), 'yyyy-MM-dd'));
    }
  }, [data]);

  const {
    control,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues
  });

  useEffect(() => {
    const handleModalHidden = () => {
      reset();
    };

    const modalElement = document.getElementById('viewVoucherModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, [reset]);

  return (
    <div className="modal" tabIndex="-1" id="viewVoucherModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <form>
            <div className="modal-header">
              <h5 className="modal-title">Detail Voucher</h5>
              <button
                id="closeModal"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-6">
                  <Controller
                    control={control}
                    name="code"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput
                          value={value}
                          type="text"
                          label="Kode Voucher"
                          isSolid={true}
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={control}
                    name="value"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput
                          value={value}
                          type="number"
                          label="Nilai (IDR)"
                          isSolid={true}
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="col-12">
                  <Controller
                    control={control}
                    name="title_id"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput value={value} type="text" label="Judul (ID)" isSolid={true} />
                      </div>
                    )}
                  />
                </div>
                <div className="col-12">
                  <Controller
                    control={control}
                    name="title_en"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput value={value} type="text" label="Judul (EN)" isSolid={true} />
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={control}
                    name="quota"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput
                          value={value}
                          type="number"
                          label="Jumlah Kuota"
                          isSolid={true}
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={control}
                    name="used"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput value={value} type="number" label="Terpakai" isSolid={true} />
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={control}
                    name="valid_from"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput
                          disabled={loading}
                          value={value}
                          type="date"
                          label="Mulai Berlaku"
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={control}
                    name="valid_thru"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput
                          disabled={loading}
                          value={value}
                          type="date"
                          label="Berlaku Hingga"
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={control}
                    name="created_at"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput
                          disabled={loading}
                          value={value}
                          type="date"
                          label="Tanggal Dibuat"
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={control}
                    name="updated_at"
                    render={({ field: { value } }) => (
                      <div className="mb-20">
                        <CustomInput
                          disabled={loading}
                          value={value}
                          type="date"
                          label="Update Terakhir"
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                data-bs-dismiss="modal"
                type="button"
                className="btn btn-primary bg-blue-1 rounded-1">
                {/* <i className="fa fa-plus mr-10"></i> */}
                <span className="fw-500">Tutup</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ViewVoucherModal;
